import { render, staticRenderFns } from "./AtividadeChecklistGrupo.vue?vue&type=template&id=024d55a9&"
import script from "./AtividadeChecklistGrupo.vue?vue&type=script&lang=js&"
export * from "./AtividadeChecklistGrupo.vue?vue&type=script&lang=js&"
import style0 from "./AtividadeChecklistGrupo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports